'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconPencil, iconPencilTag } from '@ni/nimble-components/dist/esm/icons/pencil';
import { wrap } from '../../utilities/react-wrapper';

export type { IconPencil };
export { iconPencilTag };
export const NimbleIconPencil = wrap(IconPencil);